import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "singleFields", "multiFields", "helperText"]

  connect() {
    this.cachedTabData = null
    this.hasPrePopulated = false
    if (this.checkboxTarget.checked) {
      this.hasPrePopulated = true
      this.disableFieldsIn(this.singleFieldsTarget)
    } else {
      this.disableFieldsIn(this.multiFieldsTarget)
    }
  }

  toggleMode() {
    const checked = this.checkboxTarget.checked

    if (checked) {
      this.showMultiFields()
    } else {
      this.showSingleFields()
    }
  }

  showMultiFields() {
    if (!this.hasPrePopulated) {
      this.prePopulateFirstTab()
      this.hasPrePopulated = true
    } else if (this.cachedTabData) {
      this.restoreCachedTabData()
    }

    this.singleFieldsTarget.classList.add("hidden")
    this.disableFieldsIn(this.singleFieldsTarget)

    this.multiFieldsTarget.classList.remove("hidden")
    this.enableFieldsIn(this.multiFieldsTarget)

    if (this.hasHelperTextTarget) this.helperTextTarget.classList.remove("hidden")
  }

  showSingleFields() {
    this.cacheTabData()
    this.copyFirstTabToSingle()

    this.multiFieldsTarget.classList.add("hidden")
    this.disableFieldsIn(this.multiFieldsTarget)

    this.singleFieldsTarget.classList.remove("hidden")
    this.enableFieldsIn(this.singleFieldsTarget)

    if (this.hasHelperTextTarget) this.helperTextTarget.classList.add("hidden")
  }

  prePopulateFirstTab() {
    const singleName = this.getSingleFieldValue("access_name")
    const singleNumber = this.getSingleFieldValue("access_number")
    const singleEmail = this.getSingleFieldValue("access_email")

    const firstTab = this.multiFieldsTarget.querySelector("[data-inline-tab-switcher-target='content'][data-tab-index='0']")
    if (!firstTab) return

    this.setFieldValue(firstTab, "access_name", singleName)
    this.setFieldValue(firstTab, "access_number", singleNumber)
    this.setFieldValue(firstTab, "access_email", singleEmail)
  }

  cacheTabData() {
    this.cachedTabData = {}
    const tabs = this.multiFieldsTarget.querySelectorAll("[data-inline-tab-switcher-target='content']")
    tabs.forEach((tab) => {
      const index = tab.dataset.tabIndex
      this.cachedTabData[index] = {
        access_name: this.getFieldValue(tab, "access_name"),
        access_number: this.getFieldValue(tab, "access_number"),
        access_email: this.getFieldValue(tab, "access_email"),
      }
    })
  }

  restoreCachedTabData() {
    if (!this.cachedTabData) return

    const tabs = this.multiFieldsTarget.querySelectorAll("[data-inline-tab-switcher-target='content']")
    tabs.forEach((tab) => {
      const index = tab.dataset.tabIndex
      const data = this.cachedTabData[index]
      if (!data) return

      this.setFieldValue(tab, "access_name", data.access_name)
      this.setFieldValue(tab, "access_number", data.access_number)
      this.setFieldValue(tab, "access_email", data.access_email)
    })
  }

  copyFirstTabToSingle() {
    const firstTab = this.multiFieldsTarget.querySelector("[data-inline-tab-switcher-target='content'][data-tab-index='0']")
    if (!firstTab) return

    const name = this.getFieldValue(firstTab, "access_name")
    const number = this.getFieldValue(firstTab, "access_number")
    const email = this.getFieldValue(firstTab, "access_email")

    this.setSingleFieldValue("access_name", name)
    this.setSingleFieldValue("access_number", number)
    this.setSingleFieldValue("access_email", email)
  }

  disableFieldsIn(container) {
    container.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = true
    })
  }

  enableFieldsIn(container) {
    container.querySelectorAll("input, select, textarea").forEach((field) => {
      field.disabled = false
    })
  }

  getSingleFieldValue(fieldName) {
    const input = this.singleFieldsTarget.querySelector(`[name*='[${fieldName}]']`)
    return input ? input.value : ""
  }

  setSingleFieldValue(fieldName, value) {
    const input = this.singleFieldsTarget.querySelector(`[name*='[${fieldName}]']`)
    if (input) input.value = value
  }

  getFieldValue(container, fieldName) {
    const input = container.querySelector(`[name*='[${fieldName}]']`)
    return input ? input.value : ""
  }

  setFieldValue(container, fieldName, value) {
    const input = container.querySelector(`[name*='[${fieldName}]']`)
    if (input) input.value = value
  }
}
